import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import { SectionHeading } from '@/components/ui/section-heading';
import { TeamHero } from '@/components/team/TeamHero';
import { TeamIntro } from '@/components/team/TeamIntro';
import { InstructorCard } from '@/components/team/InstructorCard';
import { AssistantCard } from '@/components/team/AssistantCard';
import { instructors, assistants } from '@/components/team/TeamData';

const Team = () => {
  return (
    <PageLayout>
      {/* Hero Section */}
      <TeamHero />

      {/* Team Introduction */}
      <TeamIntro />

      {/* Main instructors */}
      <div className="py-16">
        <div className="container mx-auto px-4">
          <SectionHeading
            subtitle="Expert Guidance"
            title="Our Instructors"
            gradient={true}
          />
          
          <div className="space-y-12 mb-16">
            {instructors.map((instructor) => (
              <InstructorCard 
                key={instructor.id}
                {...instructor}
              />
            ))}
          </div>

          {/* Assistant instructors */}
          <SectionHeading
            subtitle="Supporting Team"
            title="Our Assistants"
            gradient={true}
          />
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
            {assistants.map((assistant) => (
              <AssistantCard 
                key={assistant.id}
                {...assistant}
              />
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Team;
